'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegionService = exports.RegionService = function () {
    function RegionService(winresCloudService) {
        _classCallCheck(this, RegionService);

        this.winresCloudService = winresCloudService;
    }

    _createClass(RegionService, [{
        key: 'getRegions',
        value: function getRegions(language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetRegions', {
                'Language': language
            });
        }
    }]);

    return RegionService;
}();

RegionService.$inject = ['winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/regionService.js
// module id = 576
// module chunks = 2